const safetyDetailsMge = r => require.ensure([], () => r(require('@/page/safetyDetails/safetyDetailsMge')), 'safetyDetailsMge');
const safetyDetailsDatil = r => require.ensure([], () => r(require('@/page/safetyDetails/safetyDetailsDatil/safetyDetailsDatil')), 'safetyDetailsDatil');
const safetyDetailsList = r => require.ensure([], () => r(require('@/page/safetyDetails/safetyDetailsList/safetyDetailsList')), 'safetyDetailsList');
const safetyDetailsAdd = r => require.ensure([], () => r(require('@/page/safetyDetails/safetyDetailsAdd/safetyDetailsAdd')), 'safetyDetailsAdd');
const safetyEditor = r => require.ensure([], () => r(require('@/page/safetyDetails/safetyEditor/safetyEditor')), 'safetyEditor');

const addTemplate = r => require.ensure([], () => r(require('@/page/safetyDetails/addTemplate/addTemplate')), 'addTemplate');
const editorTemplate = r => require.ensure([], () => r(require('@/page/safetyDetails/editorTemplate/editorTemplate')), 'editorTemplate');

const SafeProductionRouter = {
  path: '',
  component: safetyDetailsMge,
  meta: {
    icon: '',
    right: [],
    isShowMenu: false,
    keepAlive:true,
  },
  name: '',
  redirect: '/safetyDetailsMge',
  children: [{
      path: '/safetyDetailsList',
      component: safetyDetailsList,
      name: '安全生产检查规则库',
      meta: {
        right: [],
        isShowMenu: false,
        keepAlive: true
      },
    },
    {
      path: '/safetyDetailsDatil',
      component: safetyDetailsDatil,
      name: '检查类型详情',
      meta: {
        right: [],
        isShowMenu: false,
        keepAlive:true
      },
    }, {
      path: '/safetyEditor',
      component: safetyEditor,
      name: '检查类型修改',
      meta: {
        right: [],
        isShowMenu: false,
        keepAlive:true
      },
    }, {
      path: '/safetyDetailsAdd',
      component: safetyDetailsAdd,
      name: '新增安全生产检查类型',
      meta: {
        right: [],
        isShowMenu: false,
        keepAlive:true
      },
    },
    {
      path: '/addTemplate',
      component: addTemplate,
      name: '新增模板',
      meta: {
        right: [],
        isShowMenu: true,
        keepAlive:true
      },
    },{
      path: '/editorTemplate',
      component: editorTemplate,
      name: '编辑模板',
      meta: {
        right: [],
        isShowMenu: false,
        keepAlive: false
      },
    }
  ]
};

export default SafeProductionRouter;
